import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import BlogPage from "@/pages/BlogPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import NewsPage from "@/pages/NewsPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/admin/leads" element={<AdminLeadsPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </BrowserRouter>
  );
}

export default App;
